/**
 * V70 엔글 마블 — PRNG (Phase 2 mock)
 *
 * Phase 3 BE 는 crypto.sha256 기반 결정론 PRNG 사용.
 * Phase 2 는 Mulberry32 로 호환 가능한 결정론 재현.
 */

export function hashSeed(seed: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function createPrng(seed: number): () => number {
  let s = seed >>> 0;
  return function () {
    s = (s + 0x6D2B79F5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function pickWeighted<T>(rand: () => number, pairs: readonly { value: T; prob: number }[]): T {
  let r = rand();
  for (const p of pairs) {
    r -= p.prob;
    if (r <= 0) return p.value;
  }
  return pairs[pairs.length - 1].value;
}

export function pickIndex(rand: () => number, length: number): number {
  return Math.floor(rand() * length);
}
